import React, { useState } from 'react';
import DocumentacaoComplementarLocal from './documentacaoComplementarLocal';
import DocumentacaoMensal from './documentacaoMensal';
import PendenciasDeloitte from './pendenciasDeloitte';
import { Collapse } from 'antd';
import { Icon, Widget } from '@digital/ui';

interface DocumentoAcessoariaProps {
  gerirDocumentacaoAcessoria: boolean;
  urlAcessoDocumentacasoAcessorial: string;
}

const AbaDocumentacaoAcessoria = (props: DocumentoAcessoariaProps) => {
  const { Panel } = Collapse;
  const { gerirDocumentacaoAcessoria, urlAcessoDocumentacasoAcessorial } = props;

  const [updaMensagem, setUpdaMensagem] = useState(false);

  const AtualizarGridMensagm = () => {
    setUpdaMensagem(true);
    setUpdaMensagem(false);
  };

  if (gerirDocumentacaoAcessoria) {
    return (
      <>
        <DocumentacaoComplementarLocal onUpdate={AtualizarGridMensagm} atualizar={updaMensagem} />
        <DocumentacaoMensal onUpdate={AtualizarGridMensagm} atualizar={updaMensagem} />
        <PendenciasDeloitte />
      </>
    );
  } else {
    return (
      <>
        <Collapse
          bordered={false}
          defaultActiveKey={['informativoDocumentacao']}
          expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key="informativoDocumentacao" header={''} style={{ border: 0 }}>
            <Widget>
              <p>
                {' '}
                A documentação previdenciária e trabalhista deverá ser encaminhada através do link{' '}
                <a href={urlAcessoDocumentacasoAcessorial} target="_blank">
                  {' '}
                  https://www.egot.com.br{' '}
                </a>{' '}
              </p>
              <p />
            </Widget>
          </Panel>
        </Collapse>
        <PendenciasDeloitte />
      </>
    );
  }
};

export default AbaDocumentacaoAcessoria;
